import React, { useEffect, useState } from "react";
import BaseSearchPage from "../baseSearchPage";
import PackageSearchResultItem from "./packageSearchResultItem";
import { useApi } from "/src/helpers/Hooks/useApi";
import { addDays, parse, format } from "date-fns";

const searchFormModelBuilder = (searchParams) => {
    const duration = parseInt(searchParams.duration);
    const start = parse(searchParams.earlyStart, "yyyy-MM-dd", new Date());
    const end = addDays(start, duration);

    return {
        dep: searchParams.from.split("-"),
        to: { code: searchParams.to, name: "unknwon" },
        startDate: format(start, "yyyy-MM-dd"),
        endDate: format(end, "yyyy-MM-dd"),
        pax: searchParams.rooms,
    };
};

export default function PackageSearchPage() {
    const apiClient = useApi();
    const fetcher = async (searchParams, filterParams, minRank, recommendedExhausted) => {
        const apiSearchParams = new URLSearchParams();
        apiSearchParams.append("from", searchParams.from);
        apiSearchParams.append("to", searchParams.to);
        apiSearchParams.append("durations", searchParams.duration);
        apiSearchParams.append("earlyStart", searchParams.earlyStart);
        apiSearchParams.append("lateStart", searchParams.lateStart);

        apiSearchParams.append("lateStart", searchParams.lateStart);
        apiSearchParams.append("rooms", searchParams.rooms);
        if (filterParams["rating"]) {
            apiSearchParams.append("fRatings", filterParams["rating"]);
        }
        if (filterParams["trip-advisor"]) {
            apiSearchParams.append("fMinTripAdvisor", filterParams["trip-advisor"]);
        }

        if (filterParams.facilities) {
            apiSearchParams.append("fFacilities", filterParams.facilities);
        }
        if (filterParams["board-basis"]) {
            apiSearchParams.append("fBoardBases", filterParams["board-basis"]);
        }
        // Merged Destination facet (mixed country/region/resort codes). The legacy
        // per-level params below still work for old shared URLs.
        if (filterParams["destinations"]) {
            apiSearchParams.append("fDestinations", filterParams["destinations"]);
        }
        if (filterParams["countries"]) {
            apiSearchParams.append("fCountries", filterParams["countries"]);
        }
        if (filterParams["regions"]) {
            apiSearchParams.append("fRegions", filterParams["regions"]);
        }
        if (filterParams["resorts"]) {
            apiSearchParams.append("fResorts", filterParams["resorts"]);
        }

        if (filterParams.sort) {
            apiSearchParams.append("sort", filterParams.sort);
        }
        if (minRank) {
            apiSearchParams.append("minRank", minRank);
        }
        if (recommendedExhausted) {
            apiSearchParams.append("recommendedExhausted", "true");
        }
        const postsData = await apiClient.doPackageSearch(apiSearchParams);

        return postsData;
    };

    const searchFormModelBuilder = (searchParams) => {
        const duration = parseInt(searchParams.duration);
        const start = parse(searchParams.earlyStart, "yyyy-MM-dd", new Date());
        const end = addDays(start, duration);

        const search = {
            dep: searchParams.from.split("-"),
            to: {
                code: searchParams.to,
                name: "unknwon",
            },
            startDate: format(start, "yyyy-MM-dd"),
            endDate: format(end, "yyyy-MM-dd"),
            pax: searchParams.rooms,
        };

        return search;
    };

    return (
        <BaseSearchPage
            resultFetcher={fetcher}
            searchFormBuilder={searchFormModelBuilder}
            resultTemplate={(x) => <PackageSearchResultItem result={x} />}
        ></BaseSearchPage>
    );
}
